import { useAuth } from "@/auth/AuthContext";
import supabase from "@/auth/Client";
import { exitViewAs, isViewingAs } from "@/auth/viewAs";
import { Button, Center, Stack, Title, useMantineTheme } from "@mantine/core";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LoginButtons } from "../Login/LoginButtons";
import { OffLogo } from "../shared/OffLogo";

type Props = {};

/**
 * This is the page that give the users the option between logging in or starting the personality test
 */
export function Landing({}: Props) {
  const theme = useMantineTheme();
  const { loginWithKakao } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const logout = async () => {
    if (isViewingAs()) {
      exitViewAs();
      return;
    }

    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error(error);
    }
  };

  const loginWithKakaoAndHandleError = async () => {
    setIsLoading(true);
    const error = await loginWithKakao();
    setIsLoading(false);
    if (error) {
      alert(error.message);
    }
    return error;
  };

  return (
    <Stack h="100%" justify="space-between" pb="lg" px="xl">
      <Center>
        <OffLogo />
      </Center>
      <Title order={1} size="2.5rem" ta="center" style={{ wordBreak: "keep-all" }}>
        매주 수요일
        <br />
        취향으로 큐레이션 되는
        <br />
        다이닝 이벤트
      </Title>
      <Stack align="center" gap="md" pb="md">
        <Button
          size="lg"
          fullWidth
          component={NavLink}
          to="/personality-test"
          color={theme.colors.yellow[0]}
          style={{ color: "black" }}
          radius="xl"
        >
          시작하기
        </Button>
        <LoginButtons onLoginWithKakao={loginWithKakaoAndHandleError} isLoading={isLoading} />
        {/* <Button component={NavLink} to="/signup" size="lg" fullWidth variant="default" radius="xl">
          회원가입
        </Button> */}
      </Stack>
    </Stack>
  );
}
